import { useTranslation } from 'react-i18next';
import { SearchInvoiceActivities } from '@/app/features/DebtorPortal/InvoiceDetail/invoiceDetail.types';
import { ActivityStatus, TransactionType } from '@/app/features/DebtorPortal/InvoiceDetail/InvoiceNotesCard/InvoiceNotesCard.types';
import { formatCurrency } from '../../utils';

export const useActivityDescriptions = (invoiceNumber: string) => {
    const { t: tPrettyStatus } = useTranslation('prettyStatus');

    const getActivityDescription = (activity: SearchInvoiceActivities): string => {
        if (activity.note) {
            return activity.note;
        }

        const amount = formatCurrency(activity.amount);
        const adjustmentType = activity.adjustmentType?.toLowerCase() ?? 'unknown';

        switch (activity.transactionType) {
            case TransactionType.Payment:
                return tPrettyStatus('paid', { invoiceNumber });
            case TransactionType.Purchase:
                return tPrettyStatus('funded', { invoiceNumber });
            case TransactionType.Submitted:
                return tPrettyStatus('submitted', {
                    invoiceNumber,
                    amount,
                });
            case TransactionType.Adjustment:
                return tPrettyStatus('adjustment', {
                    adjustmentType,
                    invoiceNumber,
                });
            case TransactionType.Chargeback:
                return tPrettyStatus('chargeback', { invoiceNumber });
            case TransactionType.ShortPay:
                return tPrettyStatus('shortPaid', { amount });
            case TransactionType.OverPay:
                return tPrettyStatus('overpay', { invoiceNumber });
            default:
                break;
        }

        switch (activity.status) {
            case ActivityStatus.Paid:
                return tPrettyStatus('paid', { invoiceNumber });
            case ActivityStatus.Funded:
                return tPrettyStatus('funded', { invoiceNumber });
            case ActivityStatus.Submitted:
                return tPrettyStatus('submitted', {
                    invoiceNumber,
                    amount,
                });
            case ActivityStatus.Recoursed:
                return tPrettyStatus('chargeback', { invoiceNumber });
            default:
                return activity.status ?? '';
        }
    };

    return { getActivityDescription };
};
